/**
 * 额外引入的插件在此进行相关配置和加载
 */

// message
import { message } from 'ant-design-vue';

// 支持SVG
import 'virtual:svg-icons-register';

// 虚拟滚动条,只引入 native 模式的特性
import vuescroll from 'vuescroll';

// 暂时有问题
// import vhCheck from 'vh-check'; //移动端浏览器100vh高度不一致 vhCheck();
// vhCheck();

export default {
	install(app: any): void {
		/* 第三方API的全局挂载(provide/inject) */

		// 页面使用inject引入antd的message函数组件
		app.provide('$message', message);

		// template模板中使用 $logs() 代表 console.log()
		app.provide('$logs', window.console.log);
		app.use(vuescroll, {
			// 设置默认的全局配置
			ops: {
				vuescroll: {
					mode: 'native',
					sizeStrategy: 'percent'
				},
				scrollPanel: { scrollingX: true },
				rail: {
					size: '5px',
					keepShow: false,
					gutterOfSide: '1px'
				},
				bar: {
					background: '#222A3D',
					size: '5px',
					specifyBorderRadius: '4px'
				}
			},
			name: 'vue-scroll'
		});
	}
};
